import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGeolocationStore } from "@/common/store/geolocationStore";
import { useUserStore } from "@/common/store";
import { useAgeVerificationStore } from "@/common/store/ageVerificationStore";
import { getAlternatePage, isAgeVerificationLocation, isLiteOnlyLocation, isPageAllowed } from "@/common/utils/geoRules";

export const useGeoBlockedPage = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const geoLocation = useGeolocationStore((state) => state.location);
  const currentUser = useUserStore((state) => state.currentUser);
  const ageVerified = useAgeVerificationStore((state) => state.ageVerified);

  useEffect(() => {
    if (isPageAllowed(pathname, geoLocation)) {
      return;
    }

    if (currentUser === undefined) {
      return;
    }

    const isLoggedIn = Boolean(currentUser?.username);

    if (isLiteOnlyLocation(geoLocation)) {
      if (isLoggedIn && !currentUser?.verified) {
        return;
      }
    } else {
      if (ageVerified !== false) {
        return;
      }

      if (isAgeVerificationLocation(geoLocation) && isLoggedIn) {
        return;
      }
    }

    const alternatePage = getAlternatePage(pathname, geoLocation, Boolean(currentUser?.verified));

    if (!alternatePage) {
      return;
    }

    if (alternatePage.startsWith("https://")) {
      window.location.replace(alternatePage);
      return;
    }

    navigate(alternatePage, { replace: true });
  }, [pathname, geoLocation, currentUser, navigate, ageVerified]);
};
